import React, { FC } from "react"
import { ContentBlock } from "./content-types/content-block"
import ContentTypes from "../../utils/ContentTypes"
import { ContentBlockWithIcon } from "./content-types/content-block-with-icon"
import { TwoColumnBulletList } from "./content-types/two-column-bullet-list"
import { Modal } from "./content-types/modal"
import { DynamicContentBlockQuote } from "./content-types/block-quote"
import {
  IBlockQuote,
  IContainer,
  IContentBlock,
  IContentBlockWithIcon,
  ITwoColumnBulletList,
  ITwoColumnLayout,
  IModal
} from "contentful-types"
import { ContentfulConditionalGate } from "../../lib/contentful/components/ContentfulConditionGate"
import { ContentfulContentProp } from "./content-types/shared-types"
import { TwoColumnLayout } from "./content-types/two-column-layout"

export type ContentfulContentTypes =
  | IBlockQuote
  | IContainer
  | IContentBlock
  | IContentBlockWithIcon
  | ITwoColumnBulletList
  | ITwoColumnLayout
  | IModal

type ContentsProps = {
  contents: Array<ContentfulContentTypes>
  childClasses?: string | null
  asList?: boolean | false
}

export const ContentfulContentRenderer: FC<ContentsProps> = ({ contents, childClasses, asList = false }) => {
  return (
    <>
      {contents?.map(
        (content) =>
          content.fields && (
            <ContentfulConditionalGate conditions={content.fields.conditions} key={content.sys.id}>
              {asList ? (
                <li className={childClasses}>
                  <Content content={content} />
                </li>
              ) : (
                <div className={childClasses}>
                  <Content content={content} />
                </div>
              )}
            </ContentfulConditionalGate>
          )
      )}
    </>
  )
}

const Content: FC<ContentfulContentProp<ContentfulContentTypes>> = ({ content }) => {
  switch (content.sys.contentType.sys.id) {
    case ContentTypes.CONTENT_BLOCK:
      return <ContentBlock content={content as IContentBlock} />
    case ContentTypes.CONTENT_BLOCK_WITH_ICON:
      return <ContentBlockWithIcon content={content as IContentBlockWithIcon} />
    case ContentTypes.CONTAINER:
      return <Container content={content as IContainer} />
    case ContentTypes.TWO_COLUMN_LAYOUT:
      return <TwoColumnLayout content={content as ITwoColumnLayout} />
    case ContentTypes.TWO_COLUMN_BULLET_LIST:
      return <TwoColumnBulletList content={content as ITwoColumnBulletList} />
    case ContentTypes.MODAL:
      return <Modal content={content as IModal} />
    case ContentTypes.BLOCK_QUOTE:
      return <DynamicContentBlockQuote content={content as IBlockQuote} />
  }
  return null
}

const Container: FC<ContentfulContentProp<IContainer>> = ({ content }) => {
  const {
    fields: { content: innerContent }
  } = content
  return <ContentfulContentRenderer contents={innerContent} />
}
